var React = require('react');

function ContentDisc (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"P5103X"},React.createElement("path",{"d":"M11.51,1.41C9.73.11,7.87.01,7.12,0,4.49-.02,2.66,1.31,2.08,1.76c-.51.44-1.55,1.46-1.93,3.06-.61,2.55.75,5.01,2.26,6.16,2.56,1.97,6.35,1.99,9,.19.2-.17.41-.34.61-.5,2.96-2.61,2.66-6.97-.51-9.27h0ZM1.02,7.02c-.12-.08-.17-.33-.2-.46-.14-.67-.06-1.51.35-2.06-.17.83-.17,1.67-.16,2.52h.01ZM13.25,5.76c.31.78.09,1.84-.45,2.47l.45-2.47Z"})));
}

ContentDisc.defaultProps = {"id":"Layer_1","version":"1.1","viewBox":"0 0 14.07 12.49"};

module.exports = ContentDisc;

ContentDisc.default = ContentDisc;
